var x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = (x) => (() => (x))
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["createRoot"]: () => (__WEBPACK_EXTERNAL_MODULE_https_esm_sh_react_dom_19_0_0_client_d20f3664__.createRoot) });